import { Directive, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { UserLevel } from '@app/core/models/user-level';
import { MenuService } from '@app/menu/services/menu.service';

@Directive({
  selector: '[portalMenuLevelIsSystem]',
  standalone: false,
})
export class MenuLevelIsSystemDirective implements OnInit {
  constructor(
    private menuService: MenuService,
    private template: TemplateRef<any>,
    private viewContainer: ViewContainerRef
  ) {}

  ngOnInit(): void {
    this.viewContainer.clear();

    if (this.menuService.isActive(UserLevel.SystemAdmin, true)) {
      this.viewContainer.createEmbeddedView(this.template);
    }
  }
}
